export const commonFormValidateMessages = {
  required: '${label} is required!',
  types: {
    number: '${label} is not a valid number!',
    url: '${label} should be a valid URL link'
  },
  number: {
    range: '${label} must be between ${min} and ${max}'
  }
};
